import React, { Component } from "react"
import styled from "@emotion/styled"
import theme from "../styles/theme"

import Icon1 from "../images/icon_1.png"
import Icon2 from "../images/icon_2.png"
import Icon3 from "../images/icon_3.png"
import Icon4 from "../images/icon_4.png"
import Icon5 from "../images/icon_5.png"

const Outer = styled.div`
  padding: 0 32px;
`

const Container = styled.div`
  align-items: center;
  max-width: ${theme.maxwidth.default};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
`
const Icon = styled.div`
  width: 100%;
  max-width: 380px;
  padding: 64px 32px;
  img {
    width: 80px;
  }
  @media (max-width: ${theme.breakpoints.tablet}) {
    max-width: unset;
  }
`

export default class IconGrid extends Component {
  render() {
    return (
      <Outer>
        <Container>
          <Icon>
            <img src={Icon1} alt="Goal Icon" />
            <h3>Define Your Goals</h3>
            <p>
              Ask the strategy questions that really matter, like what is your
              vision for success? How is that success defined? What takes you to
              that next level? Define. Align. Achieve. Repeat.
            </p>
          </Icon>
          <Icon>
            <img src={Icon2} alt="Goal Icon" />
            <h3>Evaluate and Maximise Your Time</h3>
            <p>
              Prepare yourself for success by aligning your business priorities
              with your time, to ensure yourself and your team are spending time
              in the right place.
            </p>
          </Icon>
          <Icon>
            <img src={Icon3} alt="Goal Icon" />
            <h3>Identify your prospect</h3>
            <p>
              Use key characteristics to build your ideal client and partner
              profile, targeting only those that need the solution you are
              providing and have the power and budget to make decisions.
            </p>
          </Icon>
          <Icon>
            <img src={Icon4} alt="Goal Icon" />
            <h3>Build Your Sales Cycle</h3>
            <p>
              Organize your sales process, stage by stage, defining stakeholders
              and allocating tasks to create a clearly defined and repeatable
              cycle.
            </p>
          </Icon>
          <Icon>
            <img src={Icon5} alt="Goal Icon" />
            <h3>Understand Your Sales Funnel</h3>
            <p>
              Calculate how many clients are needed in the top, and throughout
              the sales funnel, and align this with your new cycle to achieve
              your goals.
            </p>
          </Icon>
        </Container>
      </Outer>
    )
  }
}
